import { render, staticRenderFns } from "./Principle.vue?vue&type=template&id=6f117ede&scoped=true&"
import script from "./Principle.vue?vue&type=script&lang=js&"
export * from "./Principle.vue?vue&type=script&lang=js&"
import style0 from "./Principle.vue?vue&type=style&index=0&id=6f117ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f117ede",
  null
  
)

export default component.exports